import React from 'react';

export function ReplyAvatar({
  isPinned,
  imageUrl, // TOOD
}: {
  isPinned: boolean;
  imageUrl?: string;
}) {
  return (
    <div>
      {isPinned && (
        <span role="img" aria-label="Pinned">
          📌
        </span>
      )}
      <span role="img" aria-label="Avatar image">
        👤
      </span>
    </div>
  );
}
